module.exports = __webpack_public_path__ + "img/img1.759dcb99.png";